import React, { useMemo, useState } from 'react';
import { Folder, SortingOption, SortingDirection, FoldersListSorting } from '../types';
import { FoldersContext, FoldersContextBaseProps } from './Folders.context';
import { getFoldersMap } from './Folders.provider.utils';

type FoldersProviderProps = FoldersContextBaseProps & {
  foldersSorting?: FoldersListSorting | null;
  children: React.ReactNode;
};

export const FoldersProvider = (props: FoldersProviderProps) => {
  const { children, rootFolder, folderAbilities, createFolder, onFoldersSortingChange } = props;
  const [isCreateFolderDialogOpen, setIsCreateFolderDialogOpen] = useState(false);
  const [isMoveFolderDialogOpen, setIsMoveFolderDialogOpen] = useState(false);
  const [isDuplicateFolderDialogOpen, setIsDuplicateFolderDialogOpen] = useState(false);
  const [isRenameFolderDialogOpen, setIsRenameFolderDialogOpen] = useState(false);
  const [isDeleteFolderDialogOpen, setIsDeleteFolderDialogOpen] = useState(false);
  const [activeFolder, setActiveFolder] = useState<Folder>(rootFolder);
  const foldersMap = useMemo(() => getFoldersMap(rootFolder.subfolders ?? []), [rootFolder.subfolders]);
  const foldersSorting = useMemo(
    () => props.foldersSorting ?? { direction: SortingDirection.asc, option: SortingOption.Alphabetical },
    [props.foldersSorting]
  );

  return (
    <FoldersContext.Provider
      value={{
        rootFolder,
        foldersMap,
        activeFolder,
        setActiveFolder,
        createFolder,
        isCreateFolderDialogOpen,
        setIsCreateFolderDialogOpen,
        isMoveFolderDialogOpen,
        setIsMoveFolderDialogOpen,
        isDuplicateFolderDialogOpen,
        setIsDuplicateFolderDialogOpen,
        isRenameFolderDialogOpen,
        setIsRenameFolderDialogOpen,
        isDeleteFolderDialogOpen,
        setIsDeleteFolderDialogOpen,
        folderAbilities,
        foldersSorting,
        onFoldersSortingChange
      }}
    >
      {children}
    </FoldersContext.Provider>
  );
};
